import "./memberTable.scss";
import { DataGrid } from "@mui/x-data-grid";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import {
  Button,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
  CircularProgress, // Import CircularProgress for loading indicator
} from "@mui/material";
import { Add, Edit, Delete } from "@mui/icons-material";
import { useSelector } from "react-redux";

const MemberTable = () => {
  let userId = useSelector((state) => state.user.userId);
  const adminType = useSelector((state) => state.user.adminType);
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();

  // States
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true); // Loading state
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);

  if (adminType === "sAdmin") {
    userId = "1";
  }

  // Fetch all Members
  useEffect(() => {
    const fetchMember = async () => {
      setLoading(true); // Set loading state to true before fetching
      try {
        const res = await axios.get(
          `${BASE_URL}/api/member/findAllMember/${userId}`,
        );
        setData(res.data);
      } catch (err) {
        console.error("Error fetching members:", err);
      }
      setLoading(false); // Set loading state to false after data is fetched
    };
    fetchMember();
  }, [userId, BASE_URL]);

  const handleDelete = async (id) => {
    try {
      const response = await axios.delete(
        `${BASE_URL}/api/member/deleteMember/${id}`,
      );
      if (response.status === 200) {
        setData(data.filter((item) => item._id !== id));
      }
    } catch (err) {
      console.error("Error deleting member:", err);
    }
  };

  const handleUpdate = (memberData) => {
    navigate("/members/newMembers", { state: { member: memberData } }); // Pass user data to Member
  };

  const memberListColumns = [
    { field: "_id", headerName: "ID", width: 70 },
    {
      field: "fullName",
      headerName: "Full Name",
      width: 230,
      renderCell: (params) => {
        return (
          <div className="cellWithImg">
            <img className="cellImg" src={params.row.image?.url} alt="avatar" />
            {params.row.fullName}
          </div>
        );
      },
    },
    {
      field: "profession",
      headerName: "Profession",
      width: 100,
    },
    {
      field: "email",
      headerName: "Email",
      width: 100,
    },
    {
      field: "phoneNumber",
      headerName: "Phone",
      width: 100,
    },
    {
      field: "position",
      headerName: "Position",
      width: 100,
    },
    {
      field: "role",
      headerName: "Role",
      width: 100,
    },
    {
      field: "status",
      headerName: "Status",
      width: 100,
    },
  ];

  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 200,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            <IconButton color="primary" aria-label="addButton">
              <Link to="/members/newMembers">
                <Add />
              </Link>
            </IconButton>

            <IconButton
              onClick={() => handleUpdate(params.row)}
              color="primary"
              aria-label="update"
            >
              <Edit />
            </IconButton>
            <IconButton
              onClick={() => {
                setSelectedMember(params.row);
                setOpenDialog(true);
              }}
              color="error"
              aria-label="delete"
            >
              <Delete />
            </IconButton>
          </div>
        );
      },
    },
  ];

  const handleDialogClose = () => {
    setOpenDialog(false);
    setSelectedMember(null);
  };

  const handleConfirmDelete = async () => {
    if (selectedMember) {
      await handleDelete(selectedMember._id);
      setOpenDialog(false);
    }
  };

  return (
    <div className="datatable">
      <div className="datatableTitle">
        <Typography variant="h5" gutterBottom>
          List Of Members
        </Typography>
        <Link to="/members/newMembers">
          <Button variant="contained" color="primary">
            Add Member
          </Button>
        </Link>
      </div>
      <Grid container justifyContent="center">
        {loading ? ( // Show loading indicator while fetching
          <CircularProgress size={50} />
        ) : (
          <DataGrid
            className="datagrid"
            rows={data}
            columns={memberListColumns.concat(actionColumn)}
            pageSize={5}
            rowsPerPageOptions={[5]}
            checkboxSelection
            getRowId={(row) => row._id}
          />
        )}
      </Grid>

      <Dialog open={openDialog} onClose={handleDialogClose}>
        <DialogTitle>Delete Confirmation</DialogTitle>
        <DialogContent>
          <Typography>Are you sure you want to delete this Member?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirmDelete} color="error">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default MemberTable;
